import { Dialogs } from '@leverege/ui-elements';
import { GlobalState } from '@leverege/ui-redux';
import { Context } from '@leverege/plugin';
import { Attributes, DataSources } from '@leverege/ui-attributes';
import I18N from '@leverege/i18n';
import { Types } from "../../constants/index.js";
import ReleaseFirmwareToDeviceGroups from "../../views/ReleaseFirmwareToDeviceGroups.js";
const {
  tIcon
} = I18N.ns('api-ui-fota-management.ReleaseFirmwareAction');
export default {
  id: 'blueprint.action.fota.releaseFirmwareToGroups',
  name: 'Release Firmware',
  layout: {
    sort: 'firmwareRelease.pause'
  },
  matches: [{
    use: ['contextMenu', 'mobileActionBar'],
    objectType: Types.deviceGroup
  }, {
    client: ['MapBoxRolloverSelectionPointer', 'ListDataViewer'],
    use: ['contextMenu'],
    objectType: Types.deviceGroup
  }],
  isPrepared: cxt => {
    const targets = Context.getTargetsOfType(cxt, Types.deviceGroup);
    if (!(targets?.length > 0)) {
      return true;
    }
    const dType = Attributes.get('deviceTypeId', Types.deviceGroup, targets[0]);
    if (!targets.every(target => Attributes.get('deviceTypeId', Types.deviceGroup, target) === dType)) {
      return true;
    }
    const delegate = DataSources.getDelegate({
      type: Types.firmwareRelease,
      ref: '/firmwareRelease'
    });
    return delegate.canCreate() != null;
  },
  prepare: cxt => {
    const delegate = DataSources.getActions({
      type: Types.firmwareRelease,
      ref: '/firmwareRelease'
    });
    return GlobalState.dispatch(delegate.requestCanCreate());
  },
  handles: cxt => {
    const targets = Context.getTargetsOfType(cxt, Types.deviceGroup);
    if (!(targets?.length > 0)) {
      return false;
    }
    const dType = Attributes.get('deviceTypeId', Types.deviceGroup, targets[0]?.data);
    if (!targets.every(target => Attributes.get('deviceTypeId', Types.deviceGroup, target?.data) === dType)) {
      return false;
    }
    const delegate = DataSources.getDelegate({
      type: Types.firmwareRelease,
      ref: '/firmwareRelease'
    });
    return delegate.canCreate();
  },
  appearance: ({
    context
  }) => {
    const targets = Context.getTargetsOfType(context, Types.deviceGroup);
    return {
      name: `Release Firmware to ${targets.length} Group${targets.length === 1 ? '' : 's'}`,
      icon: tIcon('icon')
    };
  },
  perform: ({
    context
  }) => {
    const {
      reloadData,
      clientProps: {
        delegate
      }
    } = context;
    const targets = Context.getTargetsOfType(context, Types.deviceGroup);
    Dialogs.show({
      component: ReleaseFirmwareToDeviceGroups,
      props: {
        targets,
        delegate,
        reloadData
      }
    });
  }
};